import React from 'react'

import GamesGrid from '../../components/GamesGrid'
import { GridGame } from '../../components/GamesGrid/types'
import { Header } from './components/Header'

interface Props {
  gamesSlugs: GridGame[]
}

export default function SmartCategory({ gamesSlugs }: Props) {
  return (
    <>
      <Header />
      <GamesGrid
        games={gamesSlugs}
        rows={1}
      />
    </>
  )
}
